import React from "react";

function Hero() {
  return (
    <section
      className="banner-area-three banner-two"
      style={{
        backgroundImage: `url(${require("../../assets/img/download/02.jpg")})`,
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="banner-content-three">
              <h2 className="title wow fadeInUp" data-wow-delay=".2s">
                A Government of India Recognised Star Export House
              </h2>
              <p className="wow fadeInUp" data-wow-delay=".4s">
                Our goal is to make it as easy as possible for you to find the solution that suits your
                needs.
              </p>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
